import React, { useEffect, useState } from "react";
import heroImage from "./assets/images/Főoldal.jpg";
import logoTransparent from "./assets/images/logo_transparent.png";
import AboutSection from "./components/sections/AboutSection";
import ContactSection from "./components/sections/ContactSection";
import GallerySection from "./components/sections/GallerySection";
import PricingSection from "./components/sections/PricingSection";
import QualificationsSection from "./components/sections/QualificationsSection";
import ServicesSection from "./components/sections/ServicesSection";
import SectionHeading from "./components/shared/SectionHeading";
import SocialLinks from "./components/shared/SocialLinks";
import "./components/shared/shared.css";
import "./App.css";

const navigationItems = [
  { href: "#szolgaltatasok", label: "Szolgáltatások" },
  { href: "#rolam", label: "Rólam" },
  { href: "#galeria", label: "Galéria" },
  { href: "#arak", label: "Árak" },
  { href: "#kapcsolat", label: "Kapcsolat" },
];

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleViewportChange = () => {
      if (window.innerWidth > 820) {
        setIsMobileMenuOpen(false);
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleViewportChange);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("resize", handleViewportChange);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="site-shell">
      <header className="site-header">
        <a className="brand" href="#kezdolap" onClick={closeMobileMenu}>
          <span className="brand__name">Fizion Gyógytorna</span>
        </a>

        <button
          className="nav-toggle"
          type="button"
          aria-expanded={isMobileMenuOpen}
          aria-controls="site-navigation"
          aria-label={isMobileMenuOpen ? "Menü bezárása" : "Menü megnyitása"}
          onClick={() => setIsMobileMenuOpen((currentValue) => !currentValue)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav
          className={`site-nav${isMobileMenuOpen ? " site-nav--open" : ""}`}
          id="site-navigation"
          aria-label="Fő navigáció"
        >
          {navigationItems.map((item) => (
            <a key={item.href} href={item.href} onClick={closeMobileMenu}>
              {item.label}
            </a>
          ))}
          <a
            className="nav-phone"
            href="tel:+36209077705"
            onClick={closeMobileMenu}
          >
            +36 20 907 7705
          </a>
          <a className="nav-cta" href="#kapcsolat" onClick={closeMobileMenu}>
            Foglalás
          </a>
        </nav>
      </header>

      <main>
        <section className="hero" id="kezdolap">
          <img
            className="hero__image"
            src={heroImage}
            alt="Gyógytorna kezelés közben"
          />
          <div className="hero__overlay" />

          <div className="hero__content">
            <img
              className="hero__icon"
              src={logoTransparent}
              alt="Fizion ikon"
            />
            <h1>A fájdalommentes és egészséges mozgásért</h1>
            <p className="hero__lead">
              Szeretnél újra szabadon, fájdalom nélkül mozogni? Vagy fontos
              számodra mozgásszervrendszered egészségének megőrzése?
            </p>

            <div className="hero__actions">
              <a className="button button--primary" href="#kapcsolat">
                Időpontfoglalás
              </a>
              <a className="button button--secondary" href="#szolgaltatasok">
                Szolgáltatások
              </a>
            </div>
          </div>
        </section>

        <section className="intro section">
          <SectionHeading
            eyebrow="Személyre szabott segítség"
            title="Középpontban a biztonságos, tudatos mozgás"
            centered
          />

          <p className="intro__text">
            Káposztásmegyeren található rendelőmben szeretettel várom felnőtt és
            gyermek pácienseimet. A gyógytorna, manuálterápia és egyéb
            kiegészítő kezelések ötvözésével személyre szabott terápiás
            megoldásokat kínálok a mielőbbi felépülés és a panaszmentes
            mindennapok elérése érdekében.
          </p>
        </section>

        <ServicesSection />

        <AboutSection />

        <GallerySection />

        <PricingSection />

        <QualificationsSection />

        <ContactSection />
      </main>

      <footer className="site-footer">
        <p>Fizion Gyógytorna</p>
        <div className="footer-links">
          {navigationItems.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </div>
        <SocialLinks className="footer-socials" />
      </footer>
    </div>
  );
}

export default App;
